// This file now acts as a proxy to the reusable SDK
// to maintain backward compatibility with the rest of the app.

export * from '../lib/debug-console/types'
export * from '../lib/debug-console/store'
export { useDebug as useDebugLogs } from '../lib/debug-console/provider'
